export var WeekDay;
(function (WeekDay) {
    WeekDay[WeekDay["monday"] = 0] = "monday";
    WeekDay[WeekDay["tuesday"] = 1] = "tuesday";
    WeekDay[WeekDay["wednesday"] = 2] = "wednesday";
    WeekDay[WeekDay["thursday"] = 3] = "thursday";
    WeekDay[WeekDay["friday"] = 4] = "friday";
    WeekDay[WeekDay["saturday"] = 5] = "saturday";
    WeekDay[WeekDay["sunday"] = 6] = "sunday";
})(WeekDay || (WeekDay = {}));
export const workdays = [
    { id: WeekDay.monday, name: 'Пн' },
    { id: WeekDay.tuesday, name: 'Вт' },
    { id: WeekDay.wednesday, name: 'Ср' },
    { id: WeekDay.thursday, name: 'Чт' },
    { id: WeekDay.friday, name: 'Пт' },
];
export const weekends = [
    { id: WeekDay.saturday, name: 'Сб' },
    { id: WeekDay.sunday, name: 'Вс' },
];
export const days = [...workdays, ...weekends];
